var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100px",
  height: "100px",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "providers/schoology/icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "providers/schoology/icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#333333",
  x: 0,
  y: 0,
  width: 100,
  height: 100
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(18.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.747331,33.8220641 C25.5088968,32.569395 19.0177936,31.088968 19.0177936,24.2562278 C19.0177936,18.3345196 24.0284698,14.5765125 31.658363,14.5765125 C37.9217082,14.5765125 44.5266904,17.5373665 45.6654804,25.2811388 L39.7437722,26.0782918 C39.6298932,24.0284698 39.5160142,22.4341637 37.3523132,20.8398577 C35.1886121,19.1316726 32.683274,18.9039146 31.088968,18.9039146 C26.7615658,18.9039146 24.5978648,21.5231317 24.5978648,23.6868327 C24.5978648,26.7615658 28.1281139,27.7864769 32.455516,28.8113879 L35.5302491,29.6085409 C39.4021352,30.519573 46.4626335,32.227758 46.4626335,39.0604982 C46.4626335,44.4128114 41.7935943,49.4234875 32.683274,49.4234875 C29.0391459,49.4234875 25.1672598,48.6263345 22.5480427,46.8042705 C21.5231317,46.0071174 18.3345196,43.3879004 17.6512456,37.9217082 L23.9145907,36.8967972 C23.8007117,38.3772242 23.8007117,41.1103203 26.3060498,43.2740214 C28.2419929,44.9822064 30.747331,45.2099644 32.911032,45.2099644 C37.8078292,45.2099644 40.6548043,43.2740214 40.6548043,39.7437722 C40.6548043,35.9857651 37.8078292,35.3024911 33.8220641,34.5053381 L30.747331,33.8220641 Z",
  id: "Path",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32,0 C49.6512456,0 64.113879,14.3487544 64.113879,32 C64.113879,49.6512456 49.6512456,64 32,64 C14.3487544,64 0,49.6512456 0,32 C0,14.3487544 14.3487544,0 32,0 Z M32,5.23843416 C17.3096085,5.23843416 5.35231317,17.3096085 5.35231317,32 C5.35231317,46.6903915 17.3096085,58.7615658 32.113879,58.7615658 C46.9181495,58.7615658 58.7615658,46.6903915 58.7615658,32 C58.7615658,17.3096085 46.8042705,5.23843416 32,5.23843416 Z",
  id: "Combined-Shape",
  fill: "#8BD4F3"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.d20986be6284a772a0975a04468a2072.svg";